import styled, { css } from 'styled-components';
import Headline from '@adecco/base-app/src/components/atoms/Headline/Headline';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';
import calcrem from '@adecco/base-app/src/utilities/calcrem/calcrem';
import Paragraph from '@adecco/base-app/src/components/atoms/Paragraph/Paragraph';

export const SalaryStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 50px;
  padding-bottom: 50px;
`;

export const StyledHeadline = styled(Headline)<{ subline?: boolean }>`
  align-self: flex-start;
  margin-bottom: ${(props) => (props.subline ? `${calcrem(20)}` : '0px')};
  font-size: ${(props) =>
    props.subline ? props.theme.fontSizes.subline : props.theme.fontSizes.headline2};
  font-family: ${(props) =>
    props.subline ? props.theme.fonts.Headline : props.theme.fonts.HeadlineBold};
  line-height: ${(props) =>
    props.subline ? props.theme.lineHeights.subline : props.theme.lineHeights.headline2};

  ${moreThan('md')} {
    line-height: ${(props) =>
      props.subline
        ? props.theme.lineHeights.sublineWideScreen
        : props.theme.lineHeights.headline2WideScreen};
    font-size: ${(props) =>
      props.subline
        ? props.theme.fontSizes.sublineWideScreen
        : props.theme.fontSizes.headline2WideScreen};
    margin-bottom: ${(props) => (props.subline ? `${calcrem(45)}` : '0px')};
  }
`;

export const SalaryNumbers = styled.div`
  display: flex;
  margin-bottom: 10px;

  ${moreThan('md')} {
    width: 50%;
    margin-bottom: 30px;
  }
`;

export const SalaryRangeNumber = styled.span<{
  maxRange?: boolean;
}>`
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  font-size: ${calcrem(22)};
  line-height: ${calcrem(38)};
  color: ${(props) => (props.maxRange ? '#a3002d' : '#da291c')};

  ${moreThan('md')} {
    font-size: ${calcrem(38)};
  }
`;

export const SalaryTo = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 2;
  position: relative;

  &:before {
    content: '';
    z-index: -1;
    display: block;
    position: absolute;
    top: calc(50% - 1px);
    left: 10px;
    right: 10px;
    width: calc(100% - 20px);
    height: 2px;
    background: linear-gradient(-90deg, rgb(163, 0, 45) 0%, rgb(218, 42, 28) 100%);
  }

  ${moreThan('md')} {
    font-size: ${calcrem(38)};
  }
`;

export const SalaryToText = styled.span`
  padding: 0 10px;
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  font-size: ${calcrem(26)};
  line-height: ${calcrem(38)};
  color: #da291c;
  background: #f6f6f6;
`;

export const Scale = styled.div`
  display: flex;
  background: ${props => props.theme.backgrounds.salaryScale};
  height: 38px;
  width: 100%;
  margin-bottom: 25px;
  border-radius: 6px;

  ${moreThan('md')} {
    margin-bottom: 30px;
  }
`;

export const ScalePercent = styled.span<{
  fifty?: boolean;
}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${(props) => (props.fifty ? '50%' : '25%')};
  font-family: ${(props) => props.theme.fonts.Headline};
  font-size: ${calcrem(20)};
  line-height: ${calcrem(26)};
  color: ${(props) => (props.fifty ? props.theme.colors.white : props.theme.colors.text)};
  background: ${(props) =>
    props.fifty
      ? 'linear-gradient(90deg, rgb(218, 42, 28) 0%, rgb(163, 0, 45) 100%)'
      : 'transparent'};

  ${(props) =>
    props.fifty &&
    css`
      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        width: 6px;
        height: 44px;
        border-radius: 6px;
      }

      &:before {
        left: 0;
        background-color: #da291c;
      }

      &:after {
        right: 0;
        background-color: #a3002d;
      }
    `}

  ${moreThan('md')} {
    font-size: ${calcrem(24)};
  }
`;

export const StyledParagraph = styled(Paragraph)`
  font-size: ${calcrem(14)};
  line-height: ${calcrem(20)};
  color: ${(props) => props.theme.colors.text};

  ${moreThan('md')} {
    width: 70%;
    font-size: ${calcrem(18)};
    line-height: ${calcrem(28)};
    text-align: center;
  }
`;
